import { matchPath } from "react-router-dom"

import { buildSearchQuery, CatalogSearchQuery } from "modules/PsyCatalog/common/searchQuery"
import { goToPage } from "modules/PsyCatalog/common/models/pagination"
import { ctx } from "modules/PsyCatalog/common/ctx"
import {
    ageAtom,
    cityAtom,
    competencesAtom,
    expressSlotsAtom,
    formOfWorkAtom,
    hasChildrenAtom,
    maritalStatusAtom,
    methodsAtom,
    priceAtom,
    sexAtom,
    workingWithAtom,
} from "modules/PsyCatalog/common/models/filterForm"
import { CATALOG_PATH } from "modules/PsyCatalog/common/utils/catalogPath"
import { citiesSlugsAtom, citiesFetcher } from "modules/PsyCatalog/common/models/cities"
import { competencesSlugsAtom } from "modules/PsyCatalog/common/models/competences/competencesSlugsAtom"
import { methodsSlugsAtom } from "modules/PsyCatalog/common/models/methods/methodsSlugsAtom"
import { getCurrentPage } from "modules/PsyCatalog/common/utils/getCurrentPage"
import { isBrowser } from "utils/infrastructure/ssg-utils"

const handlers: Record<
    keyof CatalogSearchQuery,
    (value: CatalogSearchQuery[keyof CatalogSearchQuery]) => void
> = {
    city: (value) => cityAtom.parseAndUpdate(value),
    form_of_work: (value) => formOfWorkAtom.parseAndUpdate(value),
    sex: (value) => sexAtom.parseAndUpdate(value),
    marital_status: (value) => maritalStatusAtom.parseAndUpdate(value),
    has_children: (value) => hasChildrenAtom.parseAndUpdate(value),
    price_from: (value) => priceAtom.parseAndUpdateFrom(value),
    price_to: (value) => priceAtom.parseAndUpdateTo(value),
    age_from: (value) => ageAtom.parseAndUpdateFrom(value),
    age_to: (value) => ageAtom.parseAndUpdateTo(value),
    competences: (value) => competencesAtom.parseAndUpdate(value),
    methods: (value) => methodsAtom.parseAndUpdate(value),
    working_with: (value) => workingWithAtom.parseAndUpdate(value),
    express_slots: (value) => expressSlotsAtom.parseAndUpdate(value),
}

function applyFilterParam(pathname: string, query: CatalogSearchQuery) {
    const match = matchPath(CATALOG_PATH.anyFilter, pathname) // Изменён порядок аргументов
    const filterParam = match?.params?.filter

    const cityMeta = filterParam ? ctx.get(citiesSlugsAtom).get(filterParam) : undefined
    const methodMeta = filterParam ? ctx.get(methodsSlugsAtom).get(filterParam) : undefined
    const competenceMeta = filterParam ? ctx.get(competencesSlugsAtom).get(filterParam) : undefined

    if (cityMeta?.slug) {
        const city = ctx.get(citiesFetcher.dataAtom).find((c) => c.slug === cityMeta.slug)?.name
        if (city) query.city = city
    }
    if (methodMeta?.slug) {
        query.methods = [methodMeta.value]
    }
    if (competenceMeta?.slug) {
        query.competences = [competenceMeta.value]
    }
    if (matchPath(CATALOG_PATH.online, pathname)) {
        query.form_of_work = "online"
    }
    return query
}

export function onPopState() {
    const { pathname, search } = window.location
    const query = applyFilterParam(pathname, buildSearchQuery(search))
    for (const [key, value] of Object.entries(query)) {
        handlers[key as keyof typeof query](value)
    }
    goToPage(ctx, getCurrentPage())
}

isBrowser() && window.addEventListener("popstate", onPopState)
